module.exports = __webpack_public_path__ + "img/Cruze2.30e5b87b.png";